export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/exam/createexamschool',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allExamSchools'],
    })
